import React from "react";
import { SlidePages } from "../../components/slidePages";

import { EnergetiqueIcon } from "../../assets/icons/EnergetiqueIcon";
import { HiverIcon } from "../../assets/icons/HiverIcon";
import { ValorisationIcon } from "../../assets/icons/ValorisationIcon";
import { MaPrimeRénov } from "../../assets/icons/MaPrimeRénov";
import img from "../../assets/images/iteP.png"; // Assuming you have an image for ITE
import { Interventions } from "../../components/serviceDetails/intervention";
import { IntroService } from "../../components/serviceDetails/introService";
import ite1 from "../../assets/images/ite1.png";
import ite2 from "../../assets/images/ite2.png";
import { Intervention } from "../../components/apropos/intervention";
import ite3 from "../../assets/images/ite3.png"; // Assuming you have an image for ITE
import { Realisation } from "../../components/home/realisation";
import { DemandeDevis } from "../../components/home/demandeDevis";
import { Prestations } from "../../components/home/prestations";
import rea1 from "../../assets/images/rea4.png";
import rea2 from "../../assets/images/rea5.png";
import rea3 from "../../assets/images/rea6.png";
import rea4 from "../../assets/images/rea7.png";
import rea5 from "../../assets/images/rea8.png";
import rea6 from "../../assets/images/rea9.png";
export const ITEPage = () => {
  const items = [
    {
      icon: <EnergetiqueIcon />,
      text: "Réduction immédiate de la facture énergétique",
    },
    {
      icon: <ValorisationIcon />,
      text: "Valorisation immobilière",
    },
    {
      icon: <HiverIcon />,
      text: "Confort été comme hiver",
    },
    {
      icon: <MaPrimeRénov />,
      text: "Eligible à MaPrimeRénov’ et CEE",
    },
  ];
  const prestations = [
    {
      icon: ite1,
      text: "Étude thermique personnalisée",
    },
    {
      icon: ite2,
      text: "Choix des matériaux (enduit, bardage, panneaux isolants).",
    },
    {
      icon: ite3,
      text: "Pose avec finitions de qualité",
    },
  ];
  const realisations = [
    {
      image: rea1,
      text: "Isolation exterieur",
      link: "/ITE",
    },
    {
      image: rea2,
      text: "Isolation exterieur",
      link: "/ITE",
    },
    {
      image: rea3,
      text: "Isolation exterieur",
      link: "/ITE",
    },
    {
      image: rea4,
      text: "Isolation exterieur",
      link: "/ITE",
    },
    {
      image: rea5,
      text: "Isolation exterieur",
      link: "/ITE",
    },
    {
      image: rea6,
      text: "Isolation exterieur",
      link: "/ITE",
    },
  ];
  return (
    <div>
      {" "}
      <SlidePages
        title={"Isolation thermique par l’extérieur (ITE)"}
        description={
          "L’isolation thermique par l’extérieur est aujourd’hui la solution la plus performante pour isoler durablement un bâtiment. Elle permet d’améliorer l’efficacité énergétique tout en rénovant l’aspect esthétique."
        }
      />
      <IntroService items={items} img={img} />
      <Interventions
        description={
          "Des solutions sur mesure,  avec un accompagnement de A à Z."
        }
        prestations={prestations}
        title={"Notre intervention"}
      />
      <Intervention />
      <Realisation realisations={realisations} />
      <DemandeDevis title={"Obtenez votre devis ITE gratuit sous 48h"} />
      <Prestations
        title={"D’autres services"}
        description={
          "Des solutions durables pour un habitat plus beau, plus sain et moins énergivore."
        }
      />
    </div>
  );
};
